import React, {Component} from 'react';
import * as R from 'ramda';

import {toTitleCase} from 'js/common/string_helper';
import GuidelinesLight from 'js/components/guidelines_light';
import GuidelinesLightGraphql from 'js/components/guidelines_light/guidelinesLightGraphql';
import {getGuidelinesForCampaignDisplayType} from 'js/common/guideline_helper';
import hydrateAdminSession from 'js/admin_session';
import {queryMoodBoard} from 'js/graphql/queries/queryMoodBoard';

import CampaignGuidelinesListEmbed from 'js/components/campaign_guidelines_embed';

const {ContentType} = window.sn.enums;
import {FeatureFlag} from 'react-launch-darkly';

export default class GuidelinesDetails extends Component {
    state = {moodBoardImages: [], isMoodBoardImagesLoading: false};

    componentDidMount() {
        this.getCampaignMoodBoardImages(this.props.campaignId);
    }

    getCampaignMoodBoardImages = async campaignId => {
        await hydrateAdminSession();

        this.setState({isMoodBoardImagesLoading: true});
        const moodBoardContent = await queryMoodBoard([campaignId]);
        this.setState({isMoodBoardImagesLoading: false});

        if (moodBoardContent.length > 0) {
            const moodBoardImages = moodBoardContent[0].images;

            if (moodBoardImages.length > 0) {
                this.setState({
                    moodBoardImages
                });
            }
        }
    };

    displayScreenNames() {
        const {hideScreenNames, screenNames} = this.props;

        if (hideScreenNames) {
            return null;
        }
        const screenNamesVal = screenNames
            ? R.pipe(
                  R.split(','),
                  R.map(screenName =>
                      screenName.charAt(0) !== '@' ? `@${screenName}` : screenName
                  ),
                  R.join(', ')
              )(screenNames)
            : 'N/A';

        return (
            <div className="guideline-detail">
                <div className="section-details-title">Handle</div>
                <div className="section-details-value">{screenNamesVal}</div>
            </div>
        );
    }

    displayPrimaryImage() {
        const {samplePostFilename} = this.props;

        if (samplePostFilename) {
            const backgroundStyle = {
                backgroundImage: `url('${samplePostFilename}')`,
                backgroundSize: 'cover'
            };

            return (
                <a href={samplePostFilename} target="_blank" rel="noopener noreferrer">
                    <div className="primary-image-div" style={backgroundStyle} />
                </a>
            );
        }
        return (
            <div className="primary-image-div no-image">
                <div className="no-image-text">Please upload a primary image</div>
            </div>
        );
    }

    displaySecondaryContent() {
        const {samplePostImages, sampleVideoContent, campaignDisplayType} = this.props;

        const contentTypeVal = R.last(R.split('_', campaignDisplayType));

        if (
            R.equals(contentTypeVal, ContentType.IMAGE) &&
            !R.isNil(samplePostImages) &&
            !R.isEmpty(samplePostImages)
        ) {
            return R.pipe(
                R.reject(R.isNil),
                R.map(imageUrl => {
                    const samplePostImageBackgroundStyle = {
                        backgroundImage: `url('${imageUrl.url}')`,
                        backgroundSize: 'cover'
                    };

                    return (
                        <a
                            href={imageUrl.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            key={imageUrl.url}
                        >
                            <div
                                className="secondary-image"
                                style={samplePostImageBackgroundStyle}
                            />
                        </a>
                    );
                })
            )(samplePostImages);
        } else if (
            R.equals(contentTypeVal, ContentType.VIDEO) &&
            !R.isNil(sampleVideoContent) &&
            !R.isEmpty(sampleVideoContent)
        ) {
            return R.pipe(
                R.reject(R.isNil),
                R.map(video => (
                    <a href={video.url} target="_blank" rel="noopener noreferrer" key={video.url}>
                        <div className="secondary-image">
                            <video
                                src={video.url}
                                poster={video.thumbnail_url}
                                width="100%"
                                height="100%"
                            />
                        </div>
                    </a>
                ))
            )(sampleVideoContent);
        }

        return (
            <div className="secondary-image-empty-div no-image">
                <div className="no-image-text">Please upload secondary content</div>
            </div>
        );
    }

    displayMoodBoardImages = () => {
        const {moodBoardImages} = this.state;

        return R.map(moodBoard => {
            const moodBoardImageBackgroundStyle = {
                backgroundImage: `url(${moodBoard})`,
                backgroundSize: 'cover'
            };

            return (
                <a href={moodBoard} target="_blank" rel="noopener noreferrer" key={moodBoard}>
                    <div className="mood-board-image-div" style={moodBoardImageBackgroundStyle} />
                </a>
            );
        })(moodBoardImages);
    };

    renderSampleImages = (contentTypeVal, secondaryImagesCount) => {
        const {moodBoardImages, isMoodBoardImagesLoading} = this.state;

        if (moodBoardImages.length > 0) {
            return (
                <div className="guideline-detail">
                    <div className="section-details-title">Cover Image</div>
                    <div id="primary-image">{this.displayMoodBoardImages()}</div>
                </div>
            );
        }

        return (
            <div className="guideline-detail">
                <div className="section-details-title">Cover Image</div>
                <div id="primary-image">
                    <div className="primary-image-div no-image">
                        <div className="no-image-text">
                            {isMoodBoardImagesLoading ? 'Loading' : 'None'}
                        </div>
                    </div>
                </div>
            </div>
        );

        // - not removing this code as it can be restored soon
        // return (
        //     <div>
        //         <div className="guideline-detail">
        //             <div className="section-details-title">Primary Image</div>
        //             <div id="primary-image">{this.displayPrimaryImage()}</div>
        //         </div>
        //         <div className="guideline-detail">
        //             <div className="section-details-title">
        //                 {contentTypeVal === ContentType.IMAGE
        //                     ? 'Secondary Images '
        //                     : 'Secondary Videos '}
        //                 {secondaryImagesCount}
        //             </div>
        //             <div id="secondary-images">{this.displaySecondaryContent()}</div>
        //         </div>
        //     </div>
        // );
    };

    renderGuidelines = () => {
        const {isLegacyCampaign, gqlData, guidelines} = this.props;

        if (!isLegacyCampaign) {
            return (
                <GuidelinesLightGraphql
                    captionGuidelines={gqlData.captionGuidelines}
                    contentGuidelines={gqlData.contentGuidelines}
                />
            );
        }

        return <GuidelinesLight guidelines={guidelines} />;
    };

    render() {
        const {
            campaignName,
            campaignDisplayType,
            description,
            guidelines,
            hashtags,
            samplePostImages,
            sampleVideoContent,
            type,
            campaignContentWorkflow,
            maps,
            campaignId
        } = this.props;

        const pinterestGuidelines = getGuidelinesForCampaignDisplayType(
            campaignDisplayType,
            window.sn.default_guidelines
        );
        const hashtagsVal = hashtags
            ? R.pipe(R.split(','), R.map(R.concat('#')), R.join(', '))(hashtags)
            : 'N/A';
        const contentTypeVal = R.last(R.split('_', campaignDisplayType));

        let secondaryImagesCount = 0;
        if (!R.isNil(samplePostImages)) {
            secondaryImagesCount = samplePostImages.length;
        } else if (!R.isNil(sampleVideoContent)) {
            secondaryImagesCount = sampleVideoContent.length;
        }

        const campaignContentWorkflowValue = maps.CampaignContentWorkflow[campaignContentWorkflow];

        return (
            <div className="guidelines-details">
                <div className="section-title">Campaign Guidelines</div>
                <div className="guidelines-grid">
                    <div className="guidelines-details-col-1">
                        <div className="guideline-detail">
                            <div className="section-details-title">Campaign Title</div>
                            <div className="section-details-value">{campaignName}</div>
                        </div>
                        <div className="guideline-detail">
                            <div className="section-details-title">Campaign Optimized For</div>
                            <div className="section-details-value">
                                {type ? toTitleCase(type) : 'N/A'}
                            </div>
                        </div>
                        <div className="guideline-detail">
                            <div className="section-details-title">Campaign Workflow</div>
                            <div className="section-details-value">
                                {campaignContentWorkflowValue}
                            </div>
                        </div>
                        <div className="guideline-detail">
                            <div className="section-details-title">Hashtags</div>
                            <div className="section-details-value">{hashtagsVal}</div>
                        </div>
                        {this.displayScreenNames()}
                        {this.renderSampleImages(contentTypeVal, secondaryImagesCount)}
                    </div>
                    <div className="guidelines-details-col-2">
                        <div className="guideline-detail">
                            <div className="section-details-title">Campaign Description</div>
                            <div id="campaign-description">{description || 'N/A'}</div>
                        </div>
                        <div className="guideline-detail">
                            <div className="section-details-title">Post Guidelines</div>

                            <FeatureFlag
                                flagKey="guidelines-support-rich-text"
                                renderDefaultCallback={() => {
                                    return <div>{this.renderGuidelines()}</div>;
                                }}
                                renderFeatureCallback={featureFlagValue => {
                                    if (featureFlagValue === 'on') {
                                        return (
                                            <CampaignGuidelinesListEmbed
                                                application="admin_brand"
                                                isActionsMenuShown={false}
                                                isFilterable={false}
                                                campaignId={campaignId}
                                            />
                                        );
                                    }
                                    return <div>{this.renderGuidelines()}</div>;
                                }}
                            />
                        </div>
                        {!R.isNil(pinterestGuidelines) && !R.isEmpty(pinterestGuidelines) ? (
                            <div className="guideline-detail">
                                <div className="section-details-title">
                                    Pinterest Best Practices
                                </div>
                                <GuidelinesLight guidelines={pinterestGuidelines} />
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/verify_receipt_common/guidelines_details.js